module.exports = __webpack_public_path__ + "img/icon-sale-side.50c7aff8.png";